class ParallaxImageModule {
    constructor(selector) {
        this.selector = selector;
        this.parallaxImages = document.querySelectorAll(selector);
        this.initParallaxImage();
    }

    initParallaxImage() {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            this.parallaxImages.forEach(function (image) {
                image.classList.add('safari');
            });
        }
    }
}

export default ParallaxImageModule;
